
// Format all campaigns
export const formatCampaigns = ({ campaigns }) => {
  return campaigns.map(item => {
    return {
      id: item.id,
      triggerOnlyDuringBusinessHours:
      item.trigger_only_during_business_hours || false,
      timeOnPage: item?.trigger_rules?.time_on_page,
      url: item?.trigger_rules?.url,
    };
  });
};


const ensureTrailingSlash = ({ URL }) => {
    return URL.endsWith('/') ? URL : `${URL}/`;
  };
  
const isWildcardPattern = (url) => {
    return url.endsWith('/*');
  };
  

const matchURL = (campaignURL, currentURL) => {
    if (isWildcardPattern(campaignURL)) {
      const baseURL = campaignURL.slice(0, -1);
      return currentURL.startsWith(ensureTrailingSlash({ URL: baseURL }));
    }
    
    return stripTrailingSlash({ URL: campaignURL }) === stripTrailingSlash({ URL: currentURL });
  };
  

const stripTrailingSlash = ({ URL }) => {
    return URL.endsWith('/') ? URL.slice(0, -1) : URL;
  };

const shouldShowCampaign = (campaign, isInBusinessHours) => {
    return !campaign.triggerOnlyDuringBusinessHours || isInBusinessHours;
  };
  
  
export const filterCampaigns = ({ campaigns, currentURL, isInBusinessHours }) => {
    let firstCampaign = null;
  
    for (const campaign of campaigns) {
      const urlMatches = matchURL(campaign.url, currentURL);
      const businessHoursMatch = shouldShowCampaign(campaign, isInBusinessHours);

      if (urlMatches && businessHoursMatch) {
        if (!firstCampaign || campaign.timeOnPage < firstCampaign.timeOnPage) {
          firstCampaign = campaign;
        }
      }
    }
  
    return firstCampaign ? [{...firstCampaign}] : [];
  };
  